'use client';
import React from 'react';
import { logEvent } from '@utils/googleAnalytics';
import cn from './style.module.scss';

export default function ArtProducts(props: any) {
  const { t } = props;
  // const [isFloorPlanOpen, setIsFloorPlanOpen] = React.useState(false);

  const handleSeeFloorPlanClick = () => {
    // setIsFloorPlanOpen(true);
    logEvent({
      event: 'launch-see-floor-plans-click',
      additionalInfo: {
        link_id: 'launch-see-floor-plans-click',
      },
    });
  };
  /*const handleFloorPlanCarouselClose = () => {
    setIsFloorPlanOpen(false);
  };*/

  return (
    <section className={cn.artProducts}>
      <div className={cn.productInner}>
        <div className={cn.productBlock}>
          <div className={cn.productTheme}>
            <div className={cn.themeElement}>
              <div className={cn.themeBig}>
                <img
                  src={props.hyperImageSrc}
                  alt="Art Products - Hyper Theme Image"
                />
              </div>
              <div className={cn.themeHyper}>
                <div className={cn.hyperImage}>
                  <img
                    src={
                      'https://asset.aldar.com/damascus/launch/mp-arthouse/product_item_new.webp'
                    }
                    alt="Art Products - 360 View Preview"
                  />
                </div>
                <div className={cn.view360Icon}>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 88.97 88.967"
                    >
                      <path
                        d="M73.743,72.859c-1.769,7.027-4.457,12.989-7.753,17.252C62.4,94.756,58.049,97.447,53.3,97.447c-6.594,0-12.429-5.2-16.532-13.607A56.763,56.763,0,0,1,32.9,73.05c-6.957-1.769-12.865-4.443-17.094-7.713C11.161,61.743,8.47,57.4,8.47,52.646c0-6.6,5.2-12.429,13.607-16.532a56.759,56.759,0,0,1,11-3.92,55.935,55.935,0,0,1,3.689-10.106C40.868,13.679,46.7,8.48,53.3,8.48s12.429,5.2,16.532,13.607a56.086,56.086,0,0,1,3.74,10.3,56.046,56.046,0,0,1,10.261,3.729c8.408,4.1,13.607,9.935,13.607,16.532s-5.2,12.429-13.607,16.532a55.8,55.8,0,0,1-10.087,3.684ZM55.127,63.751a2.14,2.14,0,1,1,3.051,3l-4.331,4.4c11.006-.115,20.913-2.317,28.1-5.827,6.915-3.374,11.195-7.865,11.195-12.674s-4.277-9.3-11.195-12.677a49.6,49.6,0,0,0-7.308-2.829,84.294,84.294,0,0,1,1.448,14.746l4.21-4.148a2.14,2.14,0,1,1,3,3.051l-7.947,7.832-.022.022a2.137,2.137,0,0,1-2.939.017l-.014-.011-.025-.025-7.947-7.832a2.14,2.14,0,0,1,3-3.051l4.4,4.331a78.957,78.957,0,0,0-1.78-16.135,79.162,79.162,0,0,0-17.066-1.794,79.825,79.825,0,0,0-16.341,1.637,79.1,79.1,0,0,0-1.822,17.187A79.03,79.03,0,0,0,36.68,70.443a2.155,2.155,0,0,1,.172.734,53.091,53.091,0,0,0,3.771,10.787C44,88.879,48.488,93.159,53.3,93.159c3.335,0,6.532-2.075,9.305-5.661A40.965,40.965,0,0,0,69.01,73.947,84.027,84.027,0,0,1,54.028,75.44l4.148,4.21a2.14,2.14,0,1,1-3.051,3L47.293,74.7a2.135,2.135,0,0,1,0-3l7.832-7.947ZM31.866,68.329a86.975,86.975,0,0,1,.127-31.4,50.1,50.1,0,0,0-8.04,3.045c-6.915,3.374-11.195,7.865-11.195,12.677,0,3.335,2.075,6.532,5.661,9.305a40.784,40.784,0,0,0,13.447,6.378ZM68.811,31.308a49.622,49.622,0,0,0-2.837-7.342C62.6,17.051,58.108,12.771,53.3,12.771s-9.3,4.277-12.674,11.195a49.344,49.344,0,0,0-2.8,7.207,86.984,86.984,0,0,1,30.989.135Z"
                        transform="translate(-8.47 -8.48)"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={cn.productContent}>
            <h2>{t['productHeading']}</h2>
            <p>{t['productContent']}</p>
            <div className={cn.productButton}>
              <a
                target="_blank" rel="noopener noreferrer"
                href={`https://asset.aldar.com/damascus/launch/mp-arthouse_floorplan.pdf`}
                className={cn.floorPlanlink}
                id="launch-see-floor-plans-click"
                onClick={handleSeeFloorPlanClick}
              >
                <span>{t['productButton']}</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 13.686 13.686"
                  >
                    <path
                      d="M53.606,35.686A.605.605,0,0,1,53,35.08V22.606A.606.606,0,0,1,53.606,22h4.756a.606.606,0,0,1,0,1.212H54.212V34.474H65.475V30.323a.606.606,0,1,1,1.212,0V35.08a.605.605,0,0,1-.606.606Zm6.236-6.841a.6.6,0,0,1,0-.857l4.777-4.777H61.59a.606.606,0,0,1,0-1.212h4.491a.606.606,0,0,1,.606.606V27.1a.606.606,0,1,1-1.212,0V24.068L60.7,28.845a.606.606,0,0,1-.857,0Z"
                      transform="translate(-53 -22)"
                    />
                  </svg>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/*isFloorPlanOpen && (
        <MediaCarousel
          mediaList={FloorPlanImage}
          handleCloseGallery={handleFloorPlanCarouselClose}
        />
      )*/}
    </section>
  );
}
